var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_605_3231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_605_3231)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1666 38.1667C73.1666 40.1917 71.525 41.8333 69.4999 41.8333C67.4749 41.8333 65.8333 40.1917 65.8333 38.1667C65.8333 36.1416 67.4749 34.5 69.4999 34.5C71.525 34.5 73.1666 36.1416 73.1666 38.1667Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1666 38.1667C73.1666 40.1917 71.525 41.8333 69.4999 41.8333C67.4749 41.8333 65.8333 40.1917 65.8333 38.1667C65.8333 36.1416 67.4749 34.5 69.4999 34.5C71.525 34.5 73.1666 36.1416 73.1666 38.1667Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6832 44.9937L71.6832 44.9937L71.6891 44.9917C72.4111 44.7549 73.1666 45.3174 73.1666 46.1V54.8333C73.1666 57.6547 72.363 59.5877 71.0347 60.8211C69.6997 62.0608 67.7566 62.6667 65.3333 62.6667H48.6666C46.2432 62.6667 44.3002 62.0608 42.9651 60.8211C41.6368 59.5877 40.8333 57.6547 40.8333 54.8333V43.1667C40.8333 40.3453 41.6368 38.4123 42.9651 37.1789C44.3002 35.9392 46.2432 35.3333 48.6666 35.3333H61.3499C62.0679 35.3333 62.6203 36.0108 62.4599 36.8005L62.4599 36.8005L62.4587 36.8068C62.2618 37.845 62.2799 38.9893 62.6014 40.1501C63.2658 42.5558 65.2183 44.4722 67.6236 45.1004L67.6236 45.1005L67.6287 45.1017C69.0535 45.4579 70.4306 45.3873 71.6832 44.9937ZM63.1781 47.9744L63.1781 47.9744L63.1819 47.9714C63.927 47.366 64.045 46.2559 63.4433 45.5079C62.8496 44.7322 61.7303 44.6246 60.9867 45.2269C60.986 45.2275 60.9853 45.2281 60.9846 45.2286L59.0217 46.7922L59.0203 46.7934C58.4916 47.2177 57.7542 47.4458 56.9916 47.4458C56.229 47.4458 55.4916 47.2177 54.9629 46.7934L54.962 46.7927L49.7467 42.6271C48.9884 42.0127 47.8933 42.1652 47.2952 42.9014L47.2951 42.9013L47.2892 42.9088C46.7064 43.6549 46.8212 44.7647 47.568 45.3714L47.5712 45.374L52.7859 49.5391C53.971 50.5045 55.5032 50.9667 56.9999 50.9667C58.4994 50.9667 60.0133 50.503 61.2123 49.5404C61.2126 49.5402 61.2128 49.54 61.213 49.5399L63.1781 47.9744Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_605_3231",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_3231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_3231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_605_3231",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMail);
export default __webpack_public_path__ + "static/media/CheckMail.826a99e6bab08beb299a9d0cd57239aa.svg";
export { ForwardRef as ReactComponent };